/**
 * Northern Shopper — hardware barcode scanner input
 * Rapid keypress + Enter → NorthernShopper.Barcode.scan(code)
 */
(function () {
	"use strict";

	var buffer = "";
	var lastKeyTime = 0;
	var THRESHOLD = 50;
	var MIN_LENGTH = 4;

	/** A wedge scanner types into whatever has focus, so leave real typing alone. */
	function isTyping(target) {
		if (!target) return false;
		if (target.isContentEditable) return true;
		var tag = target.tagName;
		return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";
	}

	document.addEventListener("keypress", function (e) {
		if (isTyping(e.target)) {
			buffer = "";
			return;
		}

		var now = Date.now();
		if (now - lastKeyTime > THRESHOLD) buffer = "";
		lastKeyTime = now;

		if (e.key === "Enter") {
			if (buffer.length >= MIN_LENGTH && window.NorthernShopper && NorthernShopper.Barcode) {
				NorthernShopper.Barcode.scan(buffer);
			}
			buffer = "";
			return;
		}
		if (e.key.length === 1) {
			buffer += e.key;
		}
	});
})();
